import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Panel } from 'react-bootstrap';
import { ButtonType, Button } from '@checkmarx/cx-ui';
import styles from '../style.scss';

@inject('translationsStore', 'twoFAStore') @observer

export default class ResetRecoveryCodes extends Component {

    componentWillMount() {
        this.props.twoFAStore.changeStepInProgress(false);
    }

    handleSubmitForm = (e) => {
        e.preventDefault();
        this.props.twoFAStore.changeStepInProgress(true);
        this.props.twoFAStore.recoveryCodesMessage = this.props.translationsStore.translate('NEW_RECOVERY_CODE');
        this.props.twoFAStore.changeStep(this.props.twoFAStore.twoFactorSteps.recoverycodes);
    }

    render() {
        const { twoFactorSteps, stepInProgress } = this.props.twoFAStore;

        return (<div>
            <form onSubmit={this.handleSubmitForm}>
                <div className='tab-dialog subTitle'>
                    {this.props.translationsStore.translate('RESET_RECOVERY_CODES')}
                </div>
                <Panel className='infoPanel'>
                    <div className='boldtext'>{this.props.translationsStore.translate('RESET_RECOVERY_MESSAGE1')}</div>
                    <div>{this.props.translationsStore.translate('RESET_RECOVERY_MESSAGE2')}</div>
                    <div style={{ paddingTop: '10px' }}>{this.props.translationsStore.translate('RESET_RECOVERY_MESSAGE3')} {this.props.translationsStore.translate('RESET_RECOVERY_MESSAGE4')}<a style={{ cursor: 'pointer' }} onClick={() => this.props.twoFAStore.changeStep(twoFactorSteps.resetauthkey)}> {this.props.translationsStore.translate('RESET_RECOVERY_MESSAGE5')}</a></div>
                </Panel>
                <div className='buttonDiv'>
                    <Button
                        type="submit"
                        id="btnGenerateRecoveryCodes"
                        text={this.props.translationsStore.translate('RESET_RECOVERY_CODES')}
                        inProgress={stepInProgress}
                    />
                    <Button
                        text={this.props.translationsStore.translate('BACK')}
                        onClick={() => this.props.twoFAStore.changeStep(twoFactorSteps.authoptions)}                        
                    />
                </div>
            </form>
        </div>)
    }
}